__turbopack_context__.v({
  "avatar": "methodology-module__hYQhjq__avatar",
  "body": "methodology-module__hYQhjq__body",
  "byline": "methodology-module__hYQhjq__byline",
  "cancel": "methodology-module__hYQhjq__cancel",
  "date": "methodology-module__hYQhjq__date",
  "diagramFloat": "methodology-module__hYQhjq__diagramFloat",
  "dragging": "methodology-module__hYQhjq__dragging",
  "dropLine": "methodology-module__hYQhjq__dropLine",
  "edit": "methodology-module__hYQhjq__edit",
  "error": "methodology-module__hYQhjq__error",
  "footer": "methodology-module__hYQhjq__footer",
  "kicker": "methodology-module__hYQhjq__kicker",
  "kickerInput": "methodology-module__hYQhjq__kickerInput",
  "linkForm": "methodology-module__hYQhjq__linkForm",
  "links": "methodology-module__hYQhjq__links",
  "name": "methodology-module__hYQhjq__name",
  "page": "methodology-module__hYQhjq__page",
  "post": "methodology-module__hYQhjq__post",
  "postEditing": "methodology-module__hYQhjq__postEditing",
  "save": "methodology-module__hYQhjq__save",
  "subtitle": "methodology-module__hYQhjq__subtitle",
  "subtitleInput": "methodology-module__hYQhjq__subtitleInput",
  "titleInput": "methodology-module__hYQhjq__titleInput",
  "tool": "methodology-module__hYQhjq__tool",
  "toolItalic": "methodology-module__hYQhjq__toolItalic",
  "toolbar": "methodology-module__hYQhjq__toolbar",
  "toolbarSpacer": "methodology-module__hYQhjq__toolbarSpacer",
});
